import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import ListViewTable from "../../listview/components/ListViewTable";
import { ListTablePolicyShape } from "../../listview/proptypes";
import listTablePoliciesSelectors from "../../listview/selectors";
import { RoleShape } from "../../policies/proptypes";
import {
  MIN_WIDTH_ENTITIES,
  MIN_WIDTH_RESOURCES,
  MIN_WIDTH_SERVICES
} from "../../shared/constants";

const order = ["entity", "service", "resource"];
const columns = [
  { label: "Groups & Users", key: "entity", minWidth: MIN_WIDTH_ENTITIES },
  { label: "Services", key: "service", minWidth: MIN_WIDTH_SERVICES },
  { label: "Scopes", key: "resource", minWidth: MIN_WIDTH_RESOURCES }
];

const RoleDescription = ({ role, policies, openResources, parentUrl }) => (
  <div className="l-roles__column" style={{ gridArea: "role-details" }}>
    <div className="l-roles__column-header">
      <span className="p-muted-heading u-no-margin--bottom">Description</span>
    </div>
    {role && <div className="l-roles__description">{role.description}</div>}
    {role && (
      <ListViewTable
        columns={columns}
        orderBy={order}
        policies={policies}
        showActions={false}
        openResources={openResources}
        parentUrl={parentUrl}
      />
    )}
  </div>
);

RoleDescription.propTypes = {
  openResources: PropTypes.func.isRequired,
  policies: PropTypes.arrayOf(ListTablePolicyShape).isRequired,
  role: RoleShape,
  parentUrl: PropTypes.string.isRequired
};

RoleDescription.defaultProps = {
  role: undefined
};

const mapStateToProps = state => {
  const {
    getByCurrentRole,
    getAdminsByCurrentRole
  } = listTablePoliciesSelectors;
  return {
    policies:
      window.location.pathname === "/settings"
        ? getAdminsByCurrentRole(state)
        : getByCurrentRole(state)
  };
};

export default connect(mapStateToProps)(RoleDescription);
